<template>
  <el-row :gutter="2">
    <el-col :span="9">
      <el-button-group>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:edit')" type="warning" icon="Edit" @click="editInfo">修改</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
      </el-button-group>
      <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
          :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" @current-change="handleCurrentChange"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="name" label="字典类别名称"></el-table-column>
        <el-table-column prop="code" label="编码" width="130"></el-table-column>
        <el-table-column prop="queue" label="排序" width="60"></el-table-column>
        <el-table-column label="状态" width="60">
          <template #default="scope">
            <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
            <el-icon v-else class="close" title="禁用"><Close /></el-icon>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="15">
      <el-button-group>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:add')" type="primary" icon="Plus" @click="addInfo1">添加</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:edit')" type="warning" icon="Edit" @click="editInfo1">修改</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:del')" type="danger" icon="Delete" @click="delInfo1">删除</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:enable')" type="success" icon="CircleCheck" @click="enableInfo1(true)">启用</el-button>
        <el-button v-if="this.$fun.isQx(this.qx, 'dictionary:enable')" type="info" icon="CircleClose" @click="enableInfo1(false)">禁用</el-button>
      </el-button-group>
      <el-table v-loading="tableLoading1" :data="tableData1" highlight-current-row stripe border
          :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange1"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="name" label="字典项名称" width="150"></el-table-column>
        <el-table-column prop="value" label="字典项值" width="120"></el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column prop="queue" label="排序" width="60"></el-table-column>
        <el-table-column label="状态" width="60">
          <template #default="scope">
            <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
            <el-icon v-else class="close" title="禁用"><Close /></el-icon>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange1"
        :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
        :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
      </el-pagination>
    </el-col>
  </el-row>
  <!-- 字典类别对话框 -->
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.dicId" type="hidden"></el-input>
      <el-form-item label="类别名称" prop="name">
          <el-input v-model="form.name" class="width"></el-input>
      </el-form-item>
      <el-form-item label="类别编码" prop="code">
        <el-input v-model="form.code" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 字典项对话框 -->
  <el-dialog :title="dialogTitle1" v-model="dialogFormVisible1" :close-on-click-modal="false" :before-close="closeForm1">
    <el-form ref="formRef1" :model="form1" :rules="rules1" label-width="130px">
      <el-input v-model="form1.id" type="hidden"></el-input>
      <el-form-item label="类别名称">
          {{form1.typeName}}<el-input v-model="form1.dicId" class="none"></el-input>
      </el-form-item>
      <el-form-item label="项名称" prop="name">
          <el-input v-model="form1.name" class="width"></el-input>
      </el-form-item>
      <el-form-item label="项值" prop="value">
        <el-input v-model="form1.value" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form1.remark" type="textarea" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form1.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm1">关 闭</el-button>
        <el-button @click="resetForm1">重 填</el-button>
        <el-button type="primary" @click="saveInfo1">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'dictionary',
  data () {
    return {
      qx: '',
      tableLoading: false,
      tableData: [],
      selectionIds: '',
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        dicId: '',
        name: '',
        code: '',
        queue: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入字典类别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入字典类别编码', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      tableLoading1: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData1: [],
      selectionIds1: '',
      dialogFormVisible1: false,
      dialogTitle1: '',
      form1: {
        id: '',
        dicId: '',
        typeName: '',
        name: '',
        value: '',
        remark: '',
        queue: 0
      },
      rules1: {
        name: [
          { required: true, message: '请输入字典项名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入字典项值', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      },
      dicVal: null
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    this.getTableHeight()
    this.getData()
  },
  methods: {
    // 当表格的当前行发生变化的时候会触发该事件
    // handleCurrentRowChange (val) {
    //   this.currentRow = val
    //   // console.log('currentRow=', this.currentRow)
    // },
    handleCurrentChange (val) {
      // this.currentRow = val
      // console.log('val=', val)
      if (val !== undefined && val !== null) {
        this.dicVal = val
        this.selectionIds = val.dicId
        this.getData1()
      }
    },
    handleSelectionChange (val) {
      // console.log('val=', val)
      this.multipleSelection = val
      this.selectionIds = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selectionIds === '') {
          this.selectionIds = val[i].dicId
        } else {
          this.selectionIds += ',' + val[i].dicId
        }
      }
    },
    async getData () {
      this.tableLoading = true
      const { data: ret } = await this.$http.get(this.$api.dictlist)
      if (ret.status === 0) {
        // console.log('ret=', ret.data)
        this.tableData = ret.data
      }
      this.tableLoading = false
    },
    addInfo () {
      this.form.dicId = ''
      this.dialogTitle = '添加字典类别'
      this.dialogFormVisible = true
    },
    async editInfo () {
      if (this.multipleSelection === undefined || this.multipleSelection.length !== 1) {
        this.$message.error('请选择一条信息修改。')
        return
      }
      this.dialogFormVisible = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: ret } = await this.$http.get(this.$api.dictid + '/' + this.multipleSelection[0].dicId)
      if (ret.status === 0 && ret.data !== null) {
        // console.log(ret.data)
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改字典类别'
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          console.log('form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.dictsave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.dictdel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.dictenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    closeForm () {
      this.$refs.formRef.resetFields()
      this.dialogFormVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 125 - 39
    },
    // 数据字典项
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData1()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange1 (currentPage) {
      this.currentPage = currentPage
      this.getData1()
    },
    handleSelectionChange1 (val) {
      this.multipleSelection1 = val
      this.selectionIds1 = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selectionIds1 === '') {
          this.selectionIds1 = val[i].id
        } else {
          this.selectionIds1 += ',' + val[i].id
        }
      }
    },
    async getData1 () {
      this.tableLoading1 = true
      const params = '?dicid=' + this.dicVal.dicId + '&pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.dictitemlist + params)
      if (ret.status === 0) {
        this.tableData1 = ret.data.rows
        this.tableTotal = ret.data.total
      }
      this.tableLoading1 = false
    },
    addInfo1 () {
      if (this.dicVal === undefined || this.dicVal === null) {
        this.$message.error('请选择一条字典类别信息。')
        return
      }
      // console.log('this.dicVal=', this.dicVal)
      this.form1.id = ''
      this.form1.dicId = this.dicVal.dicId
      this.form1.typeName = this.dicVal.name
      this.dialogTitle1 = '添加字典项'
      this.dialogFormVisible1 = true
    },
    async editInfo1 () {
      if (this.multipleSelection1 === undefined || this.multipleSelection1.length !== 1) {
        this.$message.error('请选择一条信息修改。')
        return
      }
      this.dialogFormVisible1 = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: ret } = await this.$http.get(this.$api.dictitemid + '?id=' + this.multipleSelection1[0].id)
      if (ret.status === 0 && ret.data !== null) {
        // console.log(ret.data)
        const obj = ret.data
        Object.keys(this.form1).forEach(key => {
          this.form1[key] = obj[key]
        })
        this.dialogTitle1 = '修改字典项'
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo1 () {
      this.$refs.formRef1.validate(async (valid) => {
        if (valid) {
          // console.log('form1=', this.form1)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.dictitemsave, this.form1)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData1()
            this.closeForm1()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo1 () {
      if (this.selectionIds1 === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.dictitemdel + '?ids=' + this.selectionIds1)
        if (ret.status === 0) {
          this.getData1()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo1 (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds1 === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds1 + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.dictitemenable + params)
      if (ret.status === 0) {
        this.getData1()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm1 () {
      this.$refs.formRef1.resetFields()
    },
    closeForm1 () {
      this.$refs.formRef1.resetFields()
      this.dialogFormVisible1 = false
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.depatree{
  padding: 8px;
  // border: solid 1px #d3dce6;
}
.align-r{
  text-align: right;
}
</style>
